/**
 * Data Pump Feature Module
 *
 * Registers the data-pump workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the data-pump workspace component
registerWorkspaceComponent(
  'data-pump',
  lazyWorkspaceTab(() => import('./components/DataPumpTab').then((m) => ({ default: m.DataPumpTab }))),
);

// Re-export components
